export default __webpack_public_path__ + "static/media/placeholderWhite.683638fa.png";